import {Component, Input, OnInit} from "@angular/core";
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import {BoosterService} from "../../services/booster.service";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";

@Component({
    selector: 'db-booster-update',
    templateUrl: './booster-update.component.html',
    styleUrls: ['./booster-update.component.scss'],
    standalone: false
})
export class BoosterUpdateComponent implements OnInit {
  @Input() websiteId: number;
  @Input() websiteConnectedFrom: string;
  @Input() adminPluginsUrl: string;

  constructor(
    private _activeModal: DbActiveModal,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _boosterService: BoosterService
  ) {}

  ngOnInit() {
    this.resize([230, 700]);
  }

  public resize(size: [number, number]): void {
    this._activeModal.resize(...size);
  }

  public close(): void {
    this._activeModal.close();
  }

  public confirm(): void {
    this._activeModal.close();
  }

}
